import { render, staticRenderFns } from "./LsForm.vue?vue&type=template&id=4c60528c&scoped=true&"
import script from "./LsForm.vue?vue&type=script&lang=ts&"
export * from "./LsForm.vue?vue&type=script&lang=ts&"
import style0 from "./LsForm.vue?vue&type=style&index=0&id=4c60528c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60528c",
  null
  
)

export default component.exports